import { useMemo } from 'react';
import shallow from 'zustand/shallow';
import useStore from '~/store';
import { sumDatum } from '~/utils';
import useDatum from '~/hooks/useDatum';

const selector = (s) => ({
  leftColumns: s.leftColumns,
  rightColumns: s.rightColumns,
});

export default function useColumnSum() {
  const { leftColumns, rightColumns } = useStore(selector, shallow);
  const { leftDatum, rightDatum } = useDatum();

  const leftSum = useMemo(
    () =>
      sumDatum(
        leftDatum,
        leftColumns.filter((col) => col.isActive).map((col) => col.name)
      ),
    [leftColumns, leftDatum]
  );

  const rightSum = useMemo(
    () =>
      sumDatum(
        rightDatum,
        rightColumns.filter((col) => col.isActive).map((col) => col.name)
      ),
    [rightColumns, rightDatum]
  );

  return {
    leftSum,
    rightSum,
  };
}
